import {callApi} from '@/api/apibase'

export const getPaymentLink = function (locationId, orderIdentifier, origin) {
    if (locationId == null) {
        return callApi(
            'GET',
            `/api/external/greencourse/GetPaymentLink?orderIdentifier=${orderIdentifier}&origin=${origin}`,
        )
    } else {
        return callApi(
            'GET',
            `/api/external/greencourse/GetPaymentLink?locationId=${locationId}&orderIdentifier=${orderIdentifier}&origin=${origin}`,
        )
    }
}
